// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btnWrapper--kW6lc{display:flex;align-items:center;justify-content:center;margin:20px}.btnWrapper--kW6lc .cancelBtn--zTpbm{margin-right:15px}", "",{"version":3,"sources":["webpack://./src/components/common/ControlButtons/control-buttons.module.scss"],"names":[],"mappings":"AAAA,mBACE,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,WAAA,CAEA,qCACE,iBAAA","sourcesContent":[".btnWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 20px;\n\n  .cancelBtn {\n    margin-right: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnWrapper": "btnWrapper--kW6lc",
	"cancelBtn": "cancelBtn--zTpbm"
};
export default ___CSS_LOADER_EXPORT___;
